class RiseImages extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.handleVariantSelect.bind(this))

    if (this.externalEls?.['option-choice']?.element) {
      this.externalEls['option-choice'].elements.forEach(selectEl => {
        selectEl.addEventListener('change', this.changeVisibleImages.bind(this))
      })
    }

    if (this.externalEls.text?.element) {
      this.externalEls.text.elements.forEach(text => {
        text.addEventListener('change', this.changeText.bind(this))
      })
    }
  }

  changeVisibleImages (event) {
    if (!this.els.button.element) return
    const denomination = event.target.value

    this.els.button.elements.forEach(buttonEl => {
      buttonEl.setAttribute(
        'aria-hidden',
        buttonEl.dataset.denomination !== denomination,
      )
    })
  }

  handleVariantSelect (event) {
    const buttonEl = event.target.closest(this.els.button?.selector)
    const variantId = buttonEl?.dataset?.variantId
    const imageUrl = buttonEl?.dataset?.imageUrl
    const thumbnailUrl = buttonEl?.dataset?.thumbnailUrl

    if (!buttonEl || !variantId || !imageUrl || !thumbnailUrl) return

    buttonEl.classList.add('mod-Rise_SubImage-active')

    this.updateSelectedImageUrl(imageUrl)
    this.updateSelectedThumbnailUrl(thumbnailUrl)
    this.updateSelectedVariantId(variantId)
    this.updateVariantImageVisibility(variantId)
  }

  removeActive () {
    this.els.sub_image?.elements.forEach(image => {
      image.classList.remove('mod-Rise_SubImage-active')
    })
  }

  updateVariantImageVisibility (variantId) {
    if (!variantId || !this.els.image?.element) return

    this.els.image.elements.forEach(imageEl => {
      imageEl.setAttribute(
        'aria-hidden',
        imageEl.dataset.variantId !== variantId,
      )
    })
  }

  updateSelectedImageUrl (imageUrl) {
    if (!imageUrl || !this.externalEls?.gift_image?.element) return

    this.externalEls?.gift_image?.elements?.forEach(
      giftImageEl => (giftImageEl.value = imageUrl),
    )
  }

  updateSelectedThumbnailUrl (thumbnailUrl) {
    if (!thumbnailUrl || !this.externalEls?.gift_thumbnail?.element) return

    this.externalEls?.gift_thumbnail?.elements?.forEach(
      giftThumbnailEl => (giftThumbnailEl.value = thumbnailUrl),
    )
  }

  updateSelectedVariantId (variantId) {
    if (!variantId || !this.externalEls.id.element) return

    this.externalEls.id.elements.forEach(idEl => {
      idEl.value = variantId
    })
  }

  changeText (e) {
    this.setText(e.target.value)
  }

  setText (value) {
    value
      ? (this.els.text.element.innerText = `"${value}"`)
      : (this.els.text.element.innerText = '')
  }
}

if (!customElements.get('rise-images')) {
  customElements.define('rise-images', RiseImages)
}
